import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import ChartUtils from 'utils/chart';
import GlobalChartUtils from 'utils/chart';

import Chart from './chart';

export default CreateReactClass({
    displayName: 'GrowthGoalsChartContainer',

    propTypes: {
        currentRitForSubject: PropTypes.number,
        currentTerm: PropTypes.instanceOf(Immutable.Map),
        goalSettingTerms: PropTypes.instanceOf(Immutable.List).isRequired,
        growthGoals: PropTypes.instanceOf(Immutable.List),
        growthGoalYn: PropTypes.bool.isRequired,
        growthProjections: PropTypes.instanceOf(Immutable.List),
        growthProjectionsLoaded: PropTypes.bool,
        keystoneTestEvent: PropTypes.object,
        linkingStudiesData: PropTypes.object,
        linkingStudiesLoaded: PropTypes.bool,
        maxTestEvent: PropTypes.instanceOf(Immutable.Map),
        ritQuintiles: PropTypes.instanceOf(Immutable.Map),
        ritQuintilesLoaded: PropTypes.bool,
        studentBid: PropTypes.string.isRequired,
        studentTermData: PropTypes.instanceOf(Immutable.List).isRequired,
        subject: PropTypes.instanceOf(Immutable.Map).isRequired,
        targetTermNumber: PropTypes.number,
        terms: PropTypes.instanceOf(Immutable.List),
        testEvents: PropTypes.instanceOf(Immutable.List).isRequired,
        testToProjectFromForCurrentTerm: PropTypes.instanceOf(Immutable.Map),
    },

    hasNoData() {
        return (!this.props.goalSettingTerms || this.props.goalSettingTerms.isEmpty()) && !this.props.growthGoalYn;
    },

    allDataLoaded() {
        return (
            !!this.props.linkingStudiesLoaded && !!this.props.ritQuintilesLoaded && !!this.props.growthProjectionsLoaded
        );
    },

    render() {
        const filteredTerms = ChartUtils.findTermsForChart(
            this.props.terms,
            this.props.growthGoalYn,
            this.props.maxTestEvent,
            this.props.currentTerm,
            this.props.studentTermData
        );

        const termsForChart = ChartUtils.addGradeAndWeeksToTerms(filteredTerms, this.props.studentTermData);
        const utilCompatibleCourseSubject = this.props.keystoneTestEvent
            ? Immutable.Map({ bid: this.props.keystoneTestEvent.get('measurementScaleID') })
            : this.props.subject;
        const ritQuintilesForChart = ChartUtils.findRitQuintilesForChart(
            termsForChart,
            utilCompatibleCourseSubject,
            this.props.ritQuintiles
        );
        const chartContainerId = `growth-goal-chart-for-subject-${this.props.subject.get('bid')}`;

        let stateLinkingStudy,
            collegeLinkingStudies = null;
        if (this.props.linkingStudiesData && filteredTerms && !filteredTerms.isEmpty()) {
            stateLinkingStudy = ChartUtils.findLinkingStudyByType(
                this.props.linkingStudiesData,
                'STATE',
                filteredTerms.last().get('termNumber'),
                this.props.linkingStudiesData
            );
            GlobalChartUtils.collegeLinkingStudyTypes.forEach((studyType) => {
                const study = GlobalChartUtils.findLinkingStudyByType(
                    this.props.linkingStudiesData,
                    'COLLEGE',
                    filteredTerms.last().get('termNumber'),
                    this.props.linkingStudiesData,
                    studyType
                );
                if (study) {
                    if (!collegeLinkingStudies) {
                        collegeLinkingStudies = [];
                    }
                    collegeLinkingStudies.push(study);
                }
            });
        }

        const measurementScaleID = this.props.keystoneTestEvent
            ? this.props.keystoneTestEvent.get('measurementScaleID')
            : this.props.studentBid;

            console.log("collegeLinkingStudies ::"+JSON.stringify(collegeLinkingStudies))
            console.log("this.props.currentRitForSubject ::"+JSON.stringify( this.props.currentRitForSubject))
            console.log("this.allDataLoaded() ::"+this.allDataLoaded())

            console.log("this.props.growthGoals ::"+JSON.stringify(this.props.growthGoals))
            console.log("this.props.growthGoalYn ::"+JSON.stringify(this.props.growthGoalYn))
            console.log("this.props.growthProjections ::"+JSON.stringify(this.props.growthProjections))
            console.log("this.hasNoData() ::"+JSON.stringify(this.hasNoData()))
            console.log("measurementScaleID ::"+JSON.stringify(measurementScaleID))
            console.log("ritQuintilesForChart ::"+JSON.stringify(ritQuintilesForChart))
            console.log("stateLinkingStudy::"+JSON.stringify(stateLinkingStudy))
            console.log("this.props.studentBid ::"+JSON.stringify(this.props.studentBid))
            console.log("this.props.subject ::"+JSON.stringify(this.props.subject))
            console.log("this.props.targetTermNumbe ::"+JSON.stringify(this.props.targetTermNumber))
            console.log("termsForChart ::"+JSON.stringify(termsForChart))
            console.log("this.props.testEvents ::"+JSON.stringify(this.props.testEvents))
            console.log("this.props.testToProjectFromForCurrentTerm ::"+JSON.stringify(this.props.testToProjectFromForCurrentTerm))
        return (
            <Chart
                chartContainerId={chartContainerId}
                collegeLinkingStudies={collegeLinkingStudies}
                currentRit={this.props.currentRitForSubject}
                dataLoaded={this.allDataLoaded()}
                growthGoals={this.props.growthGoals}
                growthGoalYn={this.props.growthGoalYn}
                growthProjections={this.props.growthProjections}
                hasNoData={this.hasNoData()}
                measurementScaleID={measurementScaleID}
                ritQuintiles={ritQuintilesForChart}
                stateLinkingStudy={stateLinkingStudy}
                studentBid={this.props.studentBid}
                subject={this.props.subject}
                targetTermNumber={this.props.targetTermNumber}
                terms={termsForChart}
                testEvents={this.props.testEvents}
                testToProjectFromForCurrentTerm={this.props.testToProjectFromForCurrentTerm}
            />
        );
    },
});
